'use strict'

var smoothScroll = smoothScroll || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
smoothScroll.init = function () {
  smoothScroll.start()

  Drupal.behaviors.start = {
    attach: function (context, settings) {
      smoothScroll.start()
    },
  }
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(smoothScroll.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Add sooth animation on all anchor links
smoothScroll.start = function () {

  var scroll = new SmoothScroll('a[href*="#"]')

}
